function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import StaticText from 'components/Form/StaticText';
import App from 'modules/App';
import Account from 'modules/Account';
import { useFindSimilarPatient } from '../../../hooks';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import SearchPatients from '../../../partials/SearchPatients';
import SearchPatientsList from '../../../partials/SearchPatientsList';
import PatientData from './PatientData';
import styles from './ChoosePatient.pcss';
const ChoosePatient = ({ setComponentName })=>{
    const activePatient = useSelector(selectors.activePatient);
    const similarPatient = useFindSimilarPatient(activePatient);
    const sharingRequest = useSelector(selectors.sharingRequest);
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const mergePatient = useAction(actions.mergePatient, activePatient);
    const closeModal = useAction(App.actions.closeModal);
    useStyles(styles);
    const [destinationPatient, setDestinationPatient] = useState(similarPatient);
    useEffect(()=>{
        setDestinationPatient(similarPatient);
    }, [
        similarPatient
    ]);
    const onCancel = ()=>{
        closeModal();
    };
    const onSubmit = ()=>{
        mergePatient(destinationPatient, sharingRequest, activeClinicMembership);
        setComponentName('Merging');
    };
    const onPatientClick = (evt, patient)=>{
        evt.preventDefault();
        setDestinationPatient(patient);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info mb-7",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.mergePatients))
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-6",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "caption",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.activeProfile))
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "form-group",
                                children: /*#__PURE__*/ _jsx(StaticText, {
                                    value: `${activePatient.firstName} ${activePatient.lastName}`
                                })
                            }),
                            /*#__PURE__*/ _jsx(PatientData, _object_spread({}, activePatient))
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-6",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "caption",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.existingProfile))
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.searchContainer,
                                children: [
                                    /*#__PURE__*/ _jsx(SearchPatients, {
                                        forId: "mergePatients"
                                    }),
                                    /*#__PURE__*/ _jsx(SearchPatientsList, {
                                        id: "mergePatients",
                                        className: styles.foundPatients,
                                        onPatientClick: onPatientClick
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(PatientData, _object_spread({}, destinationPatient))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "modal__actions",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: "primary",
                                labelMessage: messages.buttons.cancel,
                                className: "btn--block mb-4",
                                onClick: onCancel
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-6",
                            children: /*#__PURE__*/ _jsx(Button, {
                                styleModifier: "primary",
                                labelMessage: messages.buttons.mergePatient,
                                className: "btn--block btn--filled",
                                onClick: onSubmit
                            })
                        })
                    ]
                })
            })
        ]
    });
};
export default ChoosePatient;
